import * as React from 'react';
import * as styles from './Thumbnail.css';

interface IThumbnailProps {
  img: string;
  imgSize?: string;
  icon: React.ReactNode;
  text: string;
  onClick(): void;
}

export const Thumbnail = (props: IThumbnailProps) => {
  return (
    <div
      onClick={props.onClick}
      className={styles['thumbnail']}
      style={{
        backgroundImage: `url(${props.img})`,
        backgroundSize: props.imgSize,
      }}
    >
      <div className={styles['icon']}>{props.icon}</div>
      <span className={styles['text']}>{props.text}</span>
    </div>
  );
};

Thumbnail.displayName = 'Thumbnail';
